import { jsx as a } from "react/jsx-runtime";
import { c as z } from "react/compiler-runtime";
import { getTextColorFromBackground as C } from "../../../utilities/index.js";
import { Box as M } from "@mui/material";
import { styles as u } from "./LegendMarker.styles.js";
const k = {
  xs: "0.15rem",
  sm: "0.325rem",
  md: "0.5rem",
  lg: "0.625rem",
  xl: "0.75rem",
  xxl: "1rem"
};
function j(i) {
  const t = z(14), {
    color: f,
    size: x,
    variant: g,
    text: h
  } = i, l = f === void 0 ? "grey" : f, m = x === void 0 ? "md" : x, v = g === void 0 ? "square" : g, n = h === void 0 ? "" : h;
  let o, r;
  if (t[0] !== i || t[1] !== m) {
    const {
      height: e,
      width: b
    } = i;
    o = e, r = b, !o && !r && (o = k[m], r = k[m]), t[0] = i, t[1] = m, t[2] = o, t[3] = r;
  } else
    o = t[2], r = t[3];
  const d = p(l) ? "white" : "grey";
  let c;
  t[4] !== l || t[5] !== o || t[6] !== n || t[7] !== d || t[8] !== r ? (c = (e) => /* @__PURE__ */ a(M, { bgcolor: l, height: o, width: r, fontSize: r, padding: n ? "0.75em" : 0, sx: n ? {
    ...u.baseMarker,
    color: d
  } : u.marker, ...e, children: n }), t[4] = l, t[5] = o, t[6] = n, t[7] = d, t[8] = r, t[9] = c) : c = t[9];
  const s = c;
  if (v === "disc") {
    let e;
    return t[10] !== s ? (e = /* @__PURE__ */ a(s, { borderRadius: "50%" }), t[10] = s, t[11] = e) : e = t[11], e;
  } else {
    let e;
    return t[12] !== s ? (e = /* @__PURE__ */ a(s, { borderRadius: 0.5 }), t[12] = s, t[13] = e) : e = t[13], e;
  }
}
function p(i) {
  return C(i) < 0.8;
}
export {
  j as LegendMarker
};
